import { useState, useEffect } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const FeederLayout = () => {
  const { currentUser, logout } = useAuth();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const navigate = useNavigate();
  
  // Handle window resize for responsive design
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth >= 768) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Toggle mobile menu
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  
  // Handle logout
  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div className="feeder-layout">
      {/* Mobile header with hamburger menu */}
      {isMobile && (
        <header className="mobile-header">
          <div className="container">
            <div className="mobile-header-content">
              <div className="mobile-logo">
                <img src="/logo192.png" alt="WellFed Cats" className="mobile-logo-img" />
                <span>WellFed Cats</span>
              </div>
              <div className="mobile-header-actions">
                <button 
                  className="logout-button"
                  onClick={handleLogout}
                  aria-label="Log out"
                >
                  <span className="logout-icon">🚪</span>
                </button>
                <button 
                  className="mobile-menu-toggle" 
                  onClick={toggleMobileMenu}
                  aria-label="Toggle menu"
                >
                  <span className={`hamburger ${isMobileMenuOpen ? 'open' : ''}`}>
                    <span className="hamburger-line"></span>
                    <span className="hamburger-line"></span>
                    <span className="hamburger-line"></span>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </header>
      )}

      <div className="feeder-container">
        {/* Sidebar navigation (desktop or mobile menu) */}
        <aside className={`feeder-sidebar ${isMobileMenuOpen ? 'mobile-open' : ''} ${isMobile ? 'mobile' : ''}`}>
          <div className="sidebar-header">
            {!isMobile && (
              <div className="sidebar-logo">
                <img src="/logo192.png" alt="WellFed Cats" />
                <h2>WellFed Cats</h2>
              </div>
            )}
            <div className="user-info">
              <div className="user-avatar">
                {currentUser?.name?.charAt(0) || 'F'}
              </div>
              <div className="user-details">
                <span className="user-name">{currentUser?.name || 'Feeder'}</span>
                <span className="user-type">Feeder</span>
              </div>
              {!isMobile && (
                <button 
                  className="logout-button-desktop"
                  onClick={handleLogout}
                  aria-label="Log out"
                >
                  🚪
                </button>
              )}
            </div>
          </div>

          <nav className="sidebar-nav">
            <ul>
              <li>
                <NavLink 
                  to="/feeder" 
                  end
                  className={({ isActive }) => isActive ? 'active' : ''}
                  onClick={() => isMobile && setIsMobileMenuOpen(false)}
                >
                  <i className="nav-icon">🏠</i>
                  <span>Dashboard</span>
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/feeder/my-cats" 
                  className={({ isActive }) => isActive ? 'active' : ''}
                  onClick={() => isMobile && setIsMobileMenuOpen(false)}
                >
                  <i className="nav-icon">🐱</i>
                  <span>My Cats</span>
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/feeder/feedings" 
                  className={({ isActive }) => isActive ? 'active' : ''}
                  onClick={() => isMobile && setIsMobileMenuOpen(false)}
                >
                  <i className="nav-icon">📝</i>
                  <span>Feeding History</span>
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/feeder/profile" 
                  className={({ isActive }) => isActive ? 'active' : ''}
                  onClick={() => isMobile && setIsMobileMenuOpen(false)}
                >
                  <i className="nav-icon">👤</i>
                  <span>Profile</span>
                </NavLink>
              </li>
            </ul>
          </nav>
        </aside>

        {/* Main content area */}
        <main className="feeder-main">
          <div className="feeder-content">
            <Outlet />
          </div>
        </main>
      </div>

      {/* Overlay for mobile menu */}
      {isMobile && isMobileMenuOpen && (
        <div 
          className="mobile-menu-overlay" 
          onClick={() => setIsMobileMenuOpen(false)}
        ></div>
      )}
    </div>
  );
};

export default FeederLayout; 